// The doctor's write-up for a consultation (v1).
import api from './client';

export const getComplaint = (reservationId) =>
  api.get(`/reservations/${reservationId}/complaint`).then((r) => r.data);

export const saveComplaint = (reservationId, complaint) =>
  api.put(`/reservations/${reservationId}/complaint`, complaint).then((r) => r.data);
